import { RefObject } from "react";

import { Typography } from "@mui/material";

import { TLessonDocument } from "../../../../@types";
import { TPdfViewerRef } from "../../../common/FileViewer/PdfViewer";
import pdfIcon from "../../../imagenes/pdf.svg";

export type TLessonDocumentPdfProps = {
	file: TLessonDocument;
	pdfViewerRef: RefObject<TPdfViewerRef | null>;
};

export function LessonDocumentPdf({
	file,
	pdfViewerRef,
}: TLessonDocumentPdfProps) {
	return (
		<div
			className="pdf-container"
			onClick={() => {
				pdfViewerRef.current?.open({
					location: file.location,
					fileName: file.name,
				});
			}}>
			<img src={pdfIcon} className="pdf-icon" />
			<Typography className="normal-text">{file.name}</Typography>
		</div>
	);
}
